// CAROUSEL WITH autoplay
( function ($) {
    $(document).ready(function () {
        childrenSlider();
    });
    function childrenSlider() {
        var wraps = $('.post_preview.layout_slideshow');
        if (wraps.length > 0) {
            wraps.each(function () {
                var wrap = $(this);
                var slider = wrap.find('.children_section');
                var sliderSlides = wrap.find('.children_section').find('.item_wrap');
                if (slider.length > 0 && sliderSlides.length > 2) {
                    slider.on("init", function () {
                        lazyLoadInstance.update();
                    });
                    slider.slick({
                        autoplay: false,
                        arrows: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        dots: true,
                        infinite: true,
                        appendDots: wrap.closest('.section').find('.pager'),
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        variableWidth: true,
                        centerMode: false,
                        rtl: $('html').attr('dir') == 'rtl',
                    });
                    markVisibleSlide(slider, 0);
                    // On before slide change
                    slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
                        markVisibleSlide(slider, currentSlide)
                    });
                }
            });
        }
    }
    function markVisibleSlide(wrap, currentSlide) {
        var totalWidth = wrap.width();
        wrap.find('.slick-slide').each(function (index, slide) {
            var idx = $(slide).attr('data-slick-index');
            if (idx < currentSlide) {
                $(slide).find('.description_wrap').fadeOut('fast');
            } else {
                totalWidth -= $(slide).width();
                if (totalWidth >= 0 ) {
                    $(slide).find('.description_wrap').fadeIn('fast');
                } else {
                    $(slide).find('.description_wrap').fadeOut('fast');
                }
            }
        });
    }
}(jQuery) );